import React, { useState, useEffect} from "react";
import { Modal, Button } from "react-bootstrap";
import { BsArrowRight, BsCalendarMinusFill } from "react-icons/bs";
import EuAcquisFormRequest from "../../../pages/WorkFlow/Requests/Form/EuAcquisRequestForm";
import style from "../Modal.module.scss";
import "../../../pages/DataCollection/style.css";
import RwMaketMonRequest from "../../../pages/WorkFlow/Requests/Form/RwMarketRequestForm";

const RWMARKET_MODAL_REQUEST = ({ refreshRequest, ...modalProps }) => {
    const pushRequest = () => {
        refreshRequest();
    }
    return (
        <Modal
            {...modalProps}
            aria-labelledby="contained-modal-title-vcenter"
            contentClassName={style.todisModalContainer}
            dialogClassName={style.sizeModal70}
        >
            <Modal.Header closeButton className={style.modalHeader}>
                <Modal.Title id="contained-modal-title-vcenter" className={style.modalTitle}>
                    <BsCalendarMinusFill className="me-3" />Create new Railway Market Monitoring Request
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <RwMaketMonRequest pushRequest={pushRequest} {...modalProps} />
            </Modal.Body>
        </Modal>
    )
}

export { RWMARKET_MODAL_REQUEST };